import React, { useRef, useState, useEffect } from "react";
import { Printer, Pencil, X, Save, Upload } from "lucide-react";
import { useLanguage } from "../../StoreContext/LanguageContext";
import apiService from "../../config";   // ✅ IMPORTANT
import { useSignature } from '../../DigitalSignature/UseSignatue';
import SignaturePad from '../../DigitalSignature/SignaturePad';

const TabaPautiPunarvarshan = ({ setSubComponent }) => {
  const documentRef = useRef(null);
  const { language, translations } = useLanguage();

  /* ===================== STATE ===================== */
  const [open, setOpen] = useState(false);
  const [saving, setSaving] = useState(false);
  const [loading, setLoading] = useState(true);
  const [selectedOwnerIndex, setSelectedOwnerIndex] = useState(null); // for owner-wise edit

  const [projectId, setProjectId] = useState(null);
  const [proposalId, setProposalId] = useState(null);

  const [rehabList, setRehabList] = useState([]);
  const [fullName, setFullName] = useState('');
  const [designation , setDesignation] =useState('');
const [showSignaturePad, setShowSignaturePad] = useState(false);
        const [pdfForSigning, setPdfForSigning] = useState(null);
        const [isViewerOpen, setIsViewerOpen] = useState(false);
        const [viewerFile, setViewerFile] = useState(null);
        const [previewUrl, setPreviewUrl] = useState(null);
        const {
          uploadStatus,
          uploadError,
          selectedSignDocument,
          resetSignatureState,
          setUploadStatus,
          setUploadError,
          signDocument
        } = useSignature();

  const [tippani, setTippani] = useState({
    default_content_1: "प्रमाणित करण्यात येते की, {owner_name} जिगांव तालुका {taluka_name} जिल्हा {district_name} यांना जिगांव येथील नवीन गावठाणात खालील तपशिलात दर्शविल्याप्रमाणे राहण्यासाठी भूखंड भूमिधारी हक्काने भूखंडाची किंमत वसूल करण्यात येऊन या आदेश देण्यात आला आहे. हा भूखंड महाराष्ट्र जमीन महसूल अधिनियम १९६६ खाली अर्जदारास प्रदान करण्यात आलेला आहे. उक्त कारणासाठी महाराष्ट्र जमीन महसूल अधिनियम १९६६ या मधील अटी अर्जदारास बंधनकारक राहतील",
    default_content_2: " मी {owner_name} जिगांव तालुका {taluka_name} जिल्हा {district_name} ताबा पावती लिहून देतो की, मी प्रकल्पग्रस्त असून माझी राहती जागा जिगांव प्रकल्पामुळे बाधित झाली असून मला मोड्या जिगांव ता. नांदुरा जि. बुलढाणा येथील नवीन गावठाणातील भूखंड क्रमांक {plot_no} क्षेत्र {plot_size} x {area_sq_mtr} चौ.मी. देण्यात आलेला आहे. त्याची किमत रक्कम रुपये {amount}/- मी स्टेट बँक ऑफ इंडिया बँक नांदुरा शाखेमध्ये दिनांक {compensation_date} रोजी भरलेली आहे. त्या भूखंडाचा मला आज रोजी ताबा मिळाला असून त्याबाबत तक्रार नाही.",
    date: "",
    witness_1_name: "",
    witness_2_name: "",
    witness_3_name:"",
    village_name: "",
    taluka_name: "",
    district_name: "",
    plot_no: "",
    plot_size: "",
    area_sq_mtr: "",
    boundary_north: "",
    boundary_south: "",
    boundary_east: "",
    boundary_west: ""
  });

  const formatDate = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };

  const [formData, setFormData] = useState({ ...tippani });

  useEffect(() => {
      const userData = JSON.parse(localStorage.getItem('userData') || '{}');
      setFullName(userData.full_name || '');
      setDesignation(userData.designation || '');
    }, []);

  /* ===================== GET PROJECT / PROPOSAL ===================== */
  useEffect(() => {
  const getProjectId = () => {
    const current = localStorage.getItem("currentProjectData");
    if (current) {
      const p = JSON.parse(current);
      return p.project_id || p.id;
    }

    const selected = localStorage.getItem("selectedProject");
    if (selected) {
      const p = JSON.parse(selected);
      return p.project_id || p.id;
    }

    const user = localStorage.getItem("userData");
    if (user) {
      const u = JSON.parse(user);
      return u?.data?.project_id || u?.project_id || null;
    }

    return null;
  };

  const getProposalId = () => {
    const userData = JSON.parse(localStorage.getItem("userData") || "{}");

    return (
      userData?.data?.default_proposal ||
      userData?.data?.proposal_id ||
      userData?.default_proposal ||
      userData?.proposal_id ||
      null
    );
  };

  setProjectId(getProjectId());
  setProposalId(getProposalId());
}, []);


  /* ===================== GET TABAPAVTI ===================== */
  useEffect(() => {
    const fetchTabapavti = async () => {
      if (!projectId || !proposalId) return;

      try {
        setLoading(true);

        const response = await apiService.getTabapavti(
          projectId,
          proposalId
        );

        // API returns { status: 200, data: [...array of plot records] }
        const rawData = response?.data || response || [];
        const dataArray = Array.isArray(rawData) ? rawData : [];

        if (dataArray.length > 0) {
          // Each element in array is a plot/owner record
          setRehabList(dataArray);
        }
      } catch (err) {
        // ✅ Handles 204 No Content
        console.warn("Tabapavti data not found");
      } finally {
        setLoading(false);
      }
    };

    fetchTabapavti();
  }, [projectId, proposalId]);

  /* ===================== HANDLERS ===================== */

  const handleEditClick = (ownerIndex) => {
  const owner = rehabList[ownerIndex];

  setSelectedOwnerIndex(ownerIndex);

  setFormData({
    owner_name: owner.owner_name || "",
    default_content_1: owner.default_content_1 || tippani.default_content_1,
    default_content_2: owner.default_content_2 || tippani.default_content_2,
    date: owner.date || "",
    witness_1_name: owner.witness_1_name || "",
    witness_2_name: owner.witness_2_name || "",
    witness_3_name: owner.witness_3_name || "",
    amountOfPossessionRight : owner.amountOfPossessionRight || "",
    completionDateOfPossession: owner.completionDateOfPossession || "",
    plot_no: owner.plot_no || "",
    plot_size: owner.plot_size || "",
    area_sq_mtr: owner.area_sq_mtr || "",
    taluka_name: owner.taluka_name || "",
    district_name: owner.district_name ||""

  });

  setOpen(true);
};

  const handleSave = async () => {
    if (!projectId || !proposalId) {
      alert("Project / Proposal ID missing");
      return;
    }

    try {
      setSaving(true);

      if (selectedOwnerIndex !== null) {
        // Save owner-specific fields back into rehabList
        const updatedList = rehabList.map((item, idx) => {
        if (idx !== selectedOwnerIndex) return item;

        return {
          ...item,
          default_content_1: formData.default_content_1,
          default_content_2: formData.default_content_2,
          date: formData.date,
          witness_1_name: formData.witness_1_name,
          witness_2_name: formData.witness_2_name,
          witness_3_name: formData.witness_3_name,
        };
      });

      setRehabList(updatedList);

        // POST owner-specific update
        const ownerPayload = {
          project_id: projectId,
          proposal_id: proposalId,
          rehab_id: rehabList[selectedOwnerIndex]?.owner_id,
          default_content_1: formData.default_content_1,
          default_content_2: formData.default_content_2,
          date: formData.date,
          witness_1_name: formData.witness_1_name,
          witness_2_name: formData.witness_2_name,
          witness_3_name: formData.witness_3_name,
        };
        await apiService.postAddUpdateTabapavti(ownerPayload);
      } else {
        // Global edit (common content only)
        const payload = {
          project_id: projectId,
          proposal_id: proposalId,
          rehab_id: rehabList[0]?.owner_id ?? null,
          default_content_1: formData.default_content_1,
          default_content_2: formData.default_content_2,
          date: formData.date,
          witness_1_name: formData.witness_1_name,
          witness_2_name: formData.witness_2_name,
          witness_3_name: formData.witness_3_name,
        };
        await apiService.postAddUpdateTabapavti(payload);
        setTippani({ ...tippani, ...payload });
      }

      setOpen(false);
      alert("✓ ताबा पावती यशस्वीपणे जतन झाली");
    } catch (err) {
      console.error("Save failed:", err);
      alert("❌ जतन करताना त्रुटी आली");
    } finally {
      setSaving(false);
    }
  };

  const handleUploadedFile = (e) => {
  const file = e.target.files[0];
  if (!file) return;

  resetSignatureState();     // 🔥 important
  setPdfForSigning(file);
  setShowSignaturePad(true);
};

 useEffect(() => {
  if (!selectedSignDocument) return;

  const postSignedPdf = async () => {
    try {
      const selectedProject = JSON.parse(localStorage.getItem("selectedProject") || "{}");
      const projectId = selectedProject?.id || selectedProject?.project_id;
      const proposalId = localStorage.getItem("currentProposalId");

      if (!projectId || !proposalId) {
        console.error("Missing projectId or proposalId");
        return;
      }

      await apiService.postAddSignaturePDF(
        projectId,
        proposalId,
        "TabaPauti",      // 🔁 change per section
        selectedSignDocument   // ✅ signed PDF only
      );

      const sectionRes = await apiService.getSectionFile(
        projectId,
        proposalId,
        "TabaPauti"
      );

      if (sectionRes?.isSignAvailable && sectionRes.data?.[0]?.file_path) {
        setPreviewUrl(sectionRes.data[0].file_path);
      }

    } catch (error) {
      console.error("Error posting signed PDF:", error);
    }
  };

  postSignedPdf();
}, [selectedSignDocument]);

const handleViewSignedPdf = async () => {
  try {
    const selectedProject = JSON.parse(localStorage.getItem("selectedProject") || "{}");
    const projectId = selectedProject?.id || selectedProject?.project_id;
    const proposalId = localStorage.getItem("currentProposalId");

    if (!projectId || !proposalId) {
      alert("Project or Proposal not found");
      return;
    }

    const res = await apiService.getSectionFile(
      projectId,
      proposalId,
      "TabaPauti" // 🔁 change per section
    );

    if (res?.isSignAvailable && res?.data?.[0]?.file_path) {
      setViewerFile(res.data[0].file_path);
      setIsViewerOpen(true);     // modal
      // OR 👉 window.open(res.data[0].file_path, "_blank");
    } else {
      alert("Signed document not available");
    }
  } catch (error) {
    console.error("Error viewing signed PDF:", error);
    alert("Unable to open signed document");
  }
};

const SignatureLoader = ({ text }) => (
  <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
    <div className="bg-white rounded-lg p-6 flex flex-col items-center space-y-4">
      <div className="animate-spin rounded-full h-10 w-10 border-4 border-blue-600 border-t-transparent"></div>
      <p className="text-sm font-medium text-gray-700">{text}</p>
    </div>
  </div>
);

  const handlePrint = () => {
  const printContent = documentRef.current?.innerHTML;
  
  if (!printContent) {
    alert("प्रिंट करण्यासाठी कंटेंट उपलब्ध नाही.");
    return;
  }

  const printWindow = window.open("", "", "height=900,width=1000");
  
  printWindow.document.write(`
    <html>
      <head>
        <title>ताबा पावती - ${tippani.village_name || 'जिगांव'}</title>
        <meta charset="UTF-8">
        <style>
          @page {
            size: A4 portrait;
            margin: 1.2cm 1.5cm;
          }

          body {
            font-family: "Noto Serif Devanagari", "Mangal", serif;
            font-size: 15.5px;
            line-height: 1.45;
            color: #000;
            margin: 0;
            padding: 0;
          }

          .center { text-align: center; }
          .bold { font-weight: bold; }
          .para { text-align: justify; margin: 14px 0; }

          table {
            width: 100%;
            border-collapse: collapse;
            margin: 18px 0;
          }

          table th, table td {
            border: 1px solid #000;
            padding: 8px 10px;
            vertical-align: middle;
          }

          th {
            font-weight: bold;
            text-align: center;
          }

          .signature {
            display: flex;
            justify-content: space-between;
            margin-top: 40px;
            font-size: 15px;
          }

          .text-right {
          margin-top: 40px;
          }

          .no-print, button, .noprint {
            display: none !important;
          }

          .text-center{
          text-align : center;
          font-weight : bold;
          }

          @media print {
            body {
              print-color-adjust: exact;
              -webkit-print-color-adjust: exact;
            }
          }
        </style>
      </head>
      <body>
        ${printContent}
      </body>
    </html>
  `);

  printWindow.document.close();
  
  // Give some time for fonts/styles to load (especially Devanagari)
  setTimeout(() => {
    printWindow.focus();
    printWindow.print();
  }, 800);
};

  const handleTabaButton = () => {
    setSubComponent("TabaPautiTippaniLetters");
  };

  const filteredOwners = rehabList
  .map((owner, index) => ({ ...owner, originalIndex: index }))
  .filter(owner => owner.owner_name && owner.owner_name.trim() !== "");

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        लोड होत आहे...
      </div>
    );
  }

  /* ===================== UI ===================== */
  return (
    <>
      <style>{`
        @media print {
          .no-print { display: none; }
        }

        .page {
          width: 820px;
          margin: 20px auto;
          padding: 30px;
          font-family: "Noto Serif Devanagari", serif;
          font-size: 15px;
          background: #fff;
          color: #000;
        }

        .center { text-align: center; }
        .bold { font-weight: bold; }
        .para { text-align: justify; margin: 12px 0; }

        table {
          width: 100%;
          border-collapse: collapse;
          margin: 15px 0;
        }

        table th, table td {
          border: 1px solid #000;
          padding: 6px;
        }

        .signature {
          display: flex;
          justify-content: space-between;
          margin-top: 30px;
        }
      `}</style>

      {/* ACTION BUTTONS */}
      <div className="no-print flex justify-start gap-3 mb-4">
      {/* <button className="relative">
                  <label className="flex items-center space-x-2 px-4 py-2 bg-yellow-600 text-white rounded-md hover:bg-yellow-700 cursor-pointer">
                    <Upload size={18} />
                    <span>Upload Signature</span>
                    <input
                      type="file"
                      accept="application/pdf,image/*"
                      className="hidden"
                      onChange={handleUploadedFile}
                    />
                  </label>
                </button>
      
                <button
                onClick={handleViewSignedPdf}
                className="flex items-center space-x-2 px-4 py-2 bg-purple-600 text-white rounded-md hover:bg-purple-700"
              >
                <Printer size={18} />
                <span>View Signed PDF</span>
              </button> */}

        <button
          onClick={handleTabaButton}
          className="px-4 py-2 bg-blue-700 text-white rounded"
        >
          {translations[language]?.tabaPautiTippaniLetters}
        </button>

        <button
          onClick={handlePrint}
          className="flex items-center gap-2 px-4 py-2 bg-green-600 text-white rounded"
        >
          <Printer size={18} /> Print
        </button>

        
      </div>

      <div ref={documentRef}>
  {rehabList && rehabList.length > 0 ? (
filteredOwners.map((owner) => (
        <div
        key={owner.rehab_id || owner.originalIndex}
        className="page bg-white shadow-2xl rounded-lg"
        style={{ pageBreakAfter: "always" }}
      >
        <div className="center bold">नमुना ४५ पहा</div>

        {/* Per-owner Edit button */}
        <div className="no-print flex justify-end mb-2">
          <button
            onClick={() => handleEditClick(owner.originalIndex)}
            className="flex items-center gap-1 px-3 py-1 bg-orange-500 text-white rounded text-sm"
          >
            <Pencil size={14} /> भूखंड {owner.plot_no} संपादित करा
          </button>
        </div>

        <div className="center">
          (प्रकल्प नाव - जिगांव प्रकल्प तालुका {owner.taluka_name || "-"} जिल्हा {owner.district_name || "-"})
        </div>

        <p className="para">
        {(owner.default_content_1 || tippani.default_content_1)
          .replace("{owner_name}", owner.owner_name || "")
          .replaceAll("{taluka_name}",owner.taluka_name || "")
          .replaceAll("{district_name}",owner.district_name || "") }
      </p>
        <table>
          <thead>
            <tr>
              <th>गाव</th>
              <th>तालुका</th>
              <th>जिल्हा</th>
              <th>भूखंड क्र.</th>
              <th>क्षेत्रफळ</th>
              <th>चतु:सीमा</th>
            </tr>
          </thead>

          <tbody>
            <tr>
              <td>{owner.village_name || "-"}</td>
              <td>{owner.taluka_name || "-"}</td>
              <td>{owner.district_name || "-"}</td>

              <td className="center">
                {owner.plot_no || "-"}
              </td>

              <td className="center">
                {owner.plot_size && owner.area_sq_mtr
                  ? `${owner.plot_size} × ${owner.area_sq_mtr} चौ.मी.`
                  : owner.area_sq_mtr
                  ? `${owner.area_sq_mtr} चौ.मी.`
                  : "-"}
              </td>

              <td>
                उत्तरेस – {owner.boundary_north || "-"} <br />
                दक्षिणेस – {owner.boundary_south || "-"} <br />
                पूर्वेस – {owner.boundary_east || "-"} <br />
                पश्चिमेस – {owner.boundary_west || "-"}
              </td>
            </tr>
          </tbody>
        </table>

         <div className="flex justify-between items-end mt-12 signature">
          <div>
            <b>दिनांक :</b>{" "}
            {owner.possessionReceiptIssueDate
              ? new Date(owner.possessionReceiptIssueDate).toLocaleDateString("en-GB")
              : owner.date
              ? new Date(owner.date).toLocaleDateString("en-GB")
              : ""}
          </div>

          <div className="text-right">
            <div className="font-bold text-center">{fullName}</div>
          <div>{designation}</div>
          </div>
        </div>


        <p className="font-bold text-center mt-5">ताबा पावती </p>

        <p className="para">
        {(owner.default_content_2 || tippani.default_content_2)
          .replaceAll("{owner_name}", owner.owner_name || "")
          .replaceAll("{amount}", owner.amountOfPossessionRight || "")
          .replaceAll("{compensation_date}", formatDate(owner.completionDateOfPossession) || "")
          .replaceAll("{plot_no}", owner.plot_no || "")
          .replaceAll("{plot_size}", owner.plot_size || "")
          .replaceAll("{area_sq_mtr}", owner.area_sq_mtr || "")
          .replaceAll("{taluka_name}",owner.taluka_name || "")
          .replaceAll("{district_name}",owner.district_name || "")
        }
      </p>

        <p>
          <b>दिनांक :</b>{" "}
        </p>

        <div className="signature">
          <div>
            साक्षीदार – <br /><br />
            1) {owner.witness_1_name || "____________"} <br /><br />
            2) {owner.witness_2_name || "____________"} <br /><br />
            <p>Engineer</p>
             {owner.witness_3_name || "____________"}
          </div>

          <div>
            सही <br /><br />
            ({owner.owner_name || "____________"})
          </div>
        </div>
      </div>
    ))
  ) : (
  <div className="page bg-white shadow-2xl rounded-lg">

    <div className="center bold">नमुना ४५ पहा</div>

    <div className="center">
      (प्रकल्प नाव - जिगांव प्रकल्प तालुका {tippani.taluka_name || "-"} जिल्हा {tippani.district_name || "-"})
    </div>

    <p className="para">
      {tippani.default_content_1}
    </p>

    <table>
      <thead>
        <tr>
          <th>गाव</th>
          <th>तालुका</th>
          <th>जिल्हा</th>
          <th>भूखंड क्र.</th>
          <th>क्षेत्रफळ</th>
          <th>चतु:सीमा</th>
        </tr>
      </thead>

      <tbody>
        <tr>
          <td>{tippani.village_name || "-"}</td>
          <td>{tippani.taluka_name || "-"}</td>
          <td>{tippani.district_name || "-"}</td>
          <td>{tippani.plot_no || "-"}</td>
          <td>{tippani.area_sq_mtr || "-"}</td>
          <td>
            उत्तरेस – {tippani.boundary_north || "-"} <br />
            दक्षिणेस – {tippani.boundary_south || "-"} <br />
            पूर्वेस – {tippani.boundary_east || "-"} <br />
            पश्चिमेस – {tippani.boundary_west || "-"}
          </td>
        </tr>
      </tbody>
    </table>

    <div className="flex justify-between items-end mt-12 signature">
      <div>
        <b>दिनांक :</b>{" "}
        {tippani.date
          ? new Date(tippani.date).toLocaleDateString("en-GB")
          : ""}
      </div>

      <div className="text-right">
        <div className="font-bold">{fullName}</div>
        <div>{designation}</div>
      </div>
    </div>

    
        <p className="font-bold text-center mt-5">ताबा पावती </p>

        <p className="para">
          {tippani.default_content_2}
        </p>

        <p>
          <b>दिनांक :</b>{" "}
        </p>

        <div className="signature">
          <div>
            साक्षीदार – <br /><br />
            1) {"____________"} <br /><br />
            2) {"____________"}
          </div>

          <div>
            सही <br /><br />
          </div>
        </div>

  </div>
)}
</div>


      {/* ===================== EDIT MODAL ===================== */}
      {open && (
        <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50">
          <div className="bg-white rounded-xl w-full max-w-2xl p-6 max-h-[90vh] overflow-y-auto">
            <div className="flex justify-between items-center mb-4">
              <h2 className="text-xl font-bold">
                {selectedOwnerIndex !== null
                  ? `भूखंड क्र. ${rehabList[selectedOwnerIndex]?.plot_no} - संपादित करा`
                  : "ताबा पावती संपादित करा (Global)"}
              </h2>
              <button onClick={() => setOpen(false)}>
                <X size={22} />
              </button>
            </div>

            <div className="space-y-4">
              {/* Owner-specific fields — shown only when editing a specific owner */}
              {selectedOwnerIndex !== null && (
                <>
                  <p><strong>मालक / Owner नाव</strong></p>
                  <input
                    value={formData.owner_name || ""}
                    onChange={(e) => setFormData({ ...formData, owner_name: e.target.value })}
                    placeholder="मालकाचे नाव"
                    className="w-full border p-2 rounded"
                    disabled
                  />
                </>
              )}

              {/* Common fields always shown */}
              <p><strong>प्रमाणपत्र मजकूर (भाग १)</strong></p>
              <textarea
                rows={4}
                value={formData.default_content_1
                  .replaceAll("{owner_name}", formData.owner_name || "")
                  .replaceAll("{taluka_name}",formData.taluka_name || "")
                  .replaceAll("{district_name}",formData.district_name || "")
                }
                onChange={(e) =>
                  setFormData({ ...formData, default_content_1: e.target.value })
                }
                className="w-full border p-2 rounded"
              />

              <p><strong>ताबा पावती मजकूर (भाग २)</strong></p>
              <textarea
                rows={4}
                value={formData.default_content_2
                  .replaceAll("{owner_name}", formData.owner_name || "")
                  .replaceAll("{amount}", formData.amountOfPossessionRight || "")
                  .replaceAll("{compensation_date}", formatDate(formData.completionDateOfPossession) || "")
                  .replaceAll("{plot_no}", formData.plot_no || "")
                  .replaceAll("{plot_size}", formData.plot_size || "")
                  .replaceAll("{area_sq_mtr}", formData.area_sq_mtr || "")
                  .replaceAll("{taluka_name}",formData.taluka_name || "")
                  .replaceAll("{district_name}",formData.district_name || "")
                  }
                onChange={(e) =>
                  setFormData({ ...formData, default_content_2: e.target.value })
                }
                className="w-full border p-2 rounded"
              />

              <p><strong>दिनांक</strong></p>
              <input
                type="date"
                value={formData.date ? formData.date.split("T")[0] : ""}
                onChange={(e) =>
                  setFormData({ ...formData, date: e.target.value })
                }
                className="w-full border p-2 rounded"
              />

              <p><strong>साक्षीदार १</strong></p>
              <input
                value={formData.witness_1_name}
                onChange={(e) =>
                  setFormData({ ...formData, witness_1_name: e.target.value })
                }
                placeholder="साक्षीदाराचे नाव"
                className="w-full border p-2 rounded"
              />

              <p><strong>साक्षीदार २</strong></p>
              <input
                value={formData.witness_2_name}
                onChange={(e) =>
                  setFormData({ ...formData, witness_2_name: e.target.value })
                }
                placeholder="साक्षीदाराचे नाव"
                className="w-full border p-2 rounded"
              />

              <p><strong>Engineer</strong></p>
              <input
                value={formData.witness_3_name}
                onChange={(e) =>
                  setFormData({ ...formData, witness_3_name: e.target.value })
                }
                placeholder="Engineer"
                className="w-full border p-2 rounded"
              />
            </div>

            <div className="flex justify-end gap-3 mt-6">
              <button
                onClick={() => setOpen(false)}
                className="px-4 py-2 bg-gray-500 text-white rounded"
              >
                Cancel
              </button>

              <button
                onClick={handleSave}
                disabled={saving}
                className="flex items-center gap-2 px-4 py-2 bg-green-600 text-white rounded disabled:opacity-60"
              >
                {saving ? (
                  <>
                    <div className="animate-spin h-4 w-4 border-2 border-white border-t-transparent rounded-full"></div>
                    Saving...
                  </>
                ) : (
                  <>
                    <Save size={18} /> Save
                  </>
                )}
              </button>
            </div>
          </div>
        </div>
      )}

      {showSignaturePad && pdfForSigning && (
  <SignaturePad
    pdfFile={pdfForSigning}
    onSign={(signaturesArray) => {
      setShowSignaturePad(false);

      // ✅ ONLY sign here
      signDocument(pdfForSigning, signaturesArray);

      setPdfForSigning(null);
    }}
    onCancel={() => {
      setShowSignaturePad(false);
      setPdfForSigning(null);
    }}
  />
)}

{isViewerOpen && viewerFile && (
  <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-60">
    <div className="bg-white rounded-lg w-[80%] max-w-6xl h-[80%] relative">

      <div className="flex justify-between items-center px-4 py-2 border-b">
        <h3 className="text-lg font-semibold">Signed Document</h3>
        <button
          onClick={() => setIsViewerOpen(false)}
          className="text-xl font-bold"
        >
          ✕
        </button>
      </div>

      <iframe
        src={viewerFile}
        title="Signed PDF Viewer"
        className="w-full h-full"
      />
    </div>
  </div>
)}

{(uploadStatus === "signing" || uploadStatus === "uploading") && (
  <SignatureLoader
    text={
      uploadStatus === "signing"
        ? "Applying digital signature…"
        : "Uploading signed document…"
    }
  />
)}
    </>
  );
};

export default TabaPautiPunarvarshan;